import type { CSSObjectWithLabel } from "react-select";
import tw from "tailwind-styled-components";

export const ContainerSideMenu = tw.div`
flex flex-1 min-h-0 overflow-hidden
border-r border-gray-[#E1E1E1]
`;

export const Menu = tw.aside`
pt-5
`;

export const ContainerMenuButtons = tw.div`
h-full w-full pb-4 overflow-y-auto
`;

export const ContainerButtons = tw.div`
flex flex-col gap-2 w-full
`;

export const SubmenuTitle = tw.p`
mb-2 uppercase font-bold text-sm
`;

export const SelectStyles = (isDarkMode: boolean = false) => ({
  control: (provided: CSSObjectWithLabel) => ({
    ...provided,
    cursor: "pointer",
    width: "full",
    border: isDarkMode ? "2px solid #4A4A4A" : "2px solid #DFE5EF",
    borderRadius: "0.5rem",
    boxShadow: "none",
    backgroundColor: isDarkMode ? "#232323" : "#fff",
    color: isDarkMode ? "#fff" : "#0C0A09",
    fontSize: "12px",
    "&:hover": {
      borderColor: "#1C93FF",
    },
    "&:focus": {
      borderColor: "#1C93FF",
    },
  }),
  menu: (provided: CSSObjectWithLabel) => ({
    ...provided,
    backgroundColor: isDarkMode ? "#232323" : "#fff",
    color: isDarkMode ? "#fff" : "#0C0A09",
  }),
  option: (provided: CSSObjectWithLabel, data: any) => ({
    ...provided,
    fontSize: "14px",
    color: isDarkMode ? "#fff" : "#0C0A09",
    backgroundColor: data.isFocused
      ? isDarkMode
        ? "#333"
        : "#F3F4F6"
      : isDarkMode
      ? "#232323"
      : undefined,
  }),
  singleValue: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: isDarkMode ? "#fff" : "#0C0A09",
  }),
  placeholder: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: isDarkMode ? "#aaa" : "#888",
  }),
});
